<template>
    <div class=" text-sm w-9/12 sm:w-auto sm:px-0">
        <div class="">
            <!-- <router-Link to="/dashboard/recharge"> <button @click="isOpenActive"
                    class="focus:outline-none text-white py-2 mx-auto w-11/12 h-minput bg-kbutton-1 hover:bg-kbutton-2 active:border active:border-kbutton-3 rounded flex justify-center items-center">
                    <Iconrechargecomp /> <span class="ml-2 text-sm font-semibold">{{ $t("menus.btn") }}</span></button>
            </router-link> -->
            <div class="">
                <ul>

                    <router-link tag="li" to="/dashboard" active-class="text-tex-2 font-bold bg-tex-10" exact><a
                            @click="isOpenActive"
                            class="pl-3 focus:outline-none  w-full py-4 flex justify-start items-center">
                            <Iconhome :class="subIsActive('/dashboard') ? 'svg-fill-active svg-fill': 'svg-fill-current'"/><div class="ml-2 text-sm ">{{ $t("menus.home") }}</div></a>
                    </router-link>

                    <router-link tag="li" to="/dashboard/counters" active-class="text-tex-2 font-bold bg-tex-10" exact><a
                            @click="isOpenActive"
                            class="pl-3 focus:outline-none  w-full py-4 flex justify-start items-center">
                            <Iconcompteurs :class="subIsActive('/dashboard/counters') ? 'svg-fill-active': 'svg-fill-current'"/><span
                                class="ml-2 text-sm ">{{ $t("menus.meters") }}</span></a>
                    </router-link>

                   <!-- <router-link tag="li" to="/dashboard/paymentmethods" active-class="text-tex-2 font-bold bg-tex-10" exact><a
                            @click="isOpenActive"
                            class="pl-3 focus:outline-none  w-full py-4 flex justify-start items-center">
                            <Iconpaymethod :class="subIsActive('/dashboard/paymentmethods') ? 'svg-fill-active': 'svg-fill-current'"/><span
                                class="ml-2 text-sm ">{{ $t("menus.paymentMethods") }}</span></a>
                    </router-link> !-->

                    <router-link tag="li" to="/dashboard/bills" active-class="text-tex-2 font-bold bg-tex-10" exact><a
                            @click="isOpenActive"
                            class="pl-3 focus:outline-none  w-full py-4 flex justify-start items-center">
                            <Iconfactures :class="subIsActive('/dashboard/bills') ? 'svg-fill-active': 'svg-fill-current'"/><span
                                class="ml-2 text-sm ">{{ $t("menus.bills") }}</span></a>
                    </router-link>

                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Iconhome from '../../assets/svg/dashbIcons/Accueil.svg?inline'
import Iconcompteurs from '../../assets/svg/dashbIcons/mescompteur.svg?inline'
import Iconfactures from '../../assets/svg/dashbIcons/mesfactur.svg?inline'
//import Iconpaymethod from '../../assets/svg/dashbIcons/moyenspaiment.svg?inline'
//import Iconrechargecomp from '../../assets/svg/dashbIcons/rechargecompteu.svg?inline'
export default {
    components: {
        Iconhome,
        Iconcompteurs,
        Iconfactures,
        //Iconpaymethod,
      //  Iconrechargecomp
    },
    methods: {
        isOpenActive(){
            return this.$store.commit('mutIsOpen',false);
        },
        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input]
            return paths.some(path => {
            if (this.$route.path === path) return true
            else {
                return false
            } //class="svg-fill-current" :class="{'svg-fill-active': subIsActive('/dashboard/counter')}" :class="subIsActive('/dashboard/counter') ? 'svg-fill-active': 'svg-fill-current'"
            })
        }
    },
}
</script>

<style scoped>
.svg-fill-active{
    color: #F11C33;
}
.svg-fill-current{
    color: #808080;
}
.svg-fill{
    fill: #F11C33;
}
</style>